import { Card, Table, TableBody, Box, Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DataRow } from 'app/components';
import clsx from 'clsx';
import React from 'react';
import TitleField from '../TitleField';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    width: '100%',
  },

  imageGrid: {
    marginTop: theme.spacing(2),
  },

  imageBox: {
    textAlign: 'center',
  },

  image: {
    width: '100%',
    maxHeight: 250,
    objectFit: 'contain',
    borderRadius: 8,
    border: '1px solid #ddd',
  },

  label: {
    marginTop: theme.spacing(1),
    fontWeight: 'bold',
    fontSize: 12,
  },
}));

const formatGender = (g) => {
  if (g === 'M') return 'Male';
  if (g === 'F') return 'Female';
  return g || '-';
};

const formatDate = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString();
};

const RegtankDownloadTable = ({ documents = {}, className }) => {
  const classes = useStyles();

  const docInfo = documents?.documentInfo || {};
  const ocr = documents?.ocrResults || {};
  const idvV1Info = documents?.idvV1Info || {};

  const extensions = idvV1Info?.documentExtensions || [];

  // 🔥 Collect ALL images
  const images = [
    { label: 'Front', url: docInfo.frontDocumentUrl },
    { label: 'Back', url: docInfo.backDocumentUrl },

    ...extensions.map((ext) => ({
      label: ext.key,
      url: ext.value,
    })),
  ].filter((img) => img.url); // remove empty

  return (
    <Card className={clsx(classes.card, className)}>
      <TitleField>ID Photos</TitleField>

      {/* 🔥 SHOW ALL IMAGES */}
      <Grid container spacing={2} className={classes.imageGrid}>
        {images.map((img, i) => (
          <Grid item xs={12} sm={6} md={4} key={i} className={classes.imageBox}>
            <img src={img.url} alt={img.label} className={classes.image} />
            <Typography className={classes.label}>{img.label}</Typography>
          </Grid>
        ))}
      </Grid>

      {/* 🔥 OCR TABLE */}
      <Table>
        <TableBody>
          <DataRow name="Document Type" value={docInfo.documentType || '-'} />
          <DataRow name="Country" value={ocr.idIssuingCountry || '-'} />

          <DataRow name="Full Name" value={ocr.fullName || '-'} />
          <DataRow name="ID Number" value={ocr.idNumber || '-'} />
          <DataRow name="Date of Birth" value={formatDate(ocr.dateOfBirth)} />
          <DataRow name="Gender" value={formatGender(ocr.gender)} />
          <DataRow name="Address" value={ocr.address || '-'} />

          <DataRow
            name="OCR Status"
            value={
              ocr.status === 'SUCCESS'
                ? <span style={{ color: 'green', fontWeight: 'bold' }}>SUCCESS</span>
                : ocr.status || '-'
            }
          />
        </TableBody>
      </Table>
    </Card>
  );
};

export default RegtankDownloadTable;